module.exports = __webpack_public_path__ + "static/img/ic_print.101969d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_print.svg
// module id = 2Qac
// module chunks = 1